
// 手机号验证
export const phone = { pattern: /^1[3456789]\d{9}$/, message: '请输入正确格式的手机号码', trigger: 'blur' };
// 手机号验证
export const tel = phone;
// 手机号验证
export const telephone = phone;
// 邮箱验证
export const email = { type: 'email', message: '请输入正确格式的邮箱地址', trigger: 'blur' };
// 邮箱验证
export const mail = email;
// 邮箱编辑器
// export const editor = { pattern: /(|\s+)+<\/p>|()+<\/p>/g, message: '请输入正文', trigger: 'blur' };
export const editor = null;
// 特殊符号验证
export const noSymbol = { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '请输入不包含特殊符号的字符', trigger: 'blur' };
// 浮点数验证
export const decimal = { pattern: /^\d+\.\d+$/, message: '请输入包含小数点的数字', trigger: 'blur' };
// 数字校验
export const number = { pattern: /^[A-Za-z0-9]+$/, message: '请输入数字', trigger: 'blur' };
// 英文验证
export const english = { pattern: /^[A-Za-z0-9]+$/, message: '请输入英文字符', trigger: 'blur' };
// 中文验证
export const chinese = { pattern: /^[\u4E00-\u9FA5]{2,4}$/, message: '请输入中文字符', trigger: 'blur' };
// 身份证号码验证
export const id = { pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, message: '请输入正确格式的身份证号码', trigger: 'blur' };
// 限制空格输入
export const noSpace = { pattern: /^[A-Za-z0-9\u4e00-\u9fa5\(\)]+$/, message: '不允许输入空格等特殊符号', trigger: 'blur' };
// 金额验证
export const price = { pattern: /(^[1-9]\d*.\d{1,2}$)|(^0.\d{1,2}$)|(^[1-9]\d*$)/, message: '请输入正确的价格，两位小数及整数', trigger: 'blur' };
// CRON表达式验证
export const cron = { pattern: /^(\*|([0-5]?[0-9])(-([0-5]?[0-9]))?(\/([1-9][0-9]*))?)(\s+(\*|([0-5]?[0-9])(-([0-5]?[0-9]))?(\/([1-9][0-9]*))?)){5}(\s+(\*|([1-9][0-9]*)(-([1-9][0-9]*))?(\/([1-9][0-9]*))?))?$/, message: '请输入正确的时间表达式', trigger: 'blur' };

export default { phone, tel, telephone, email, mail, editor, noSymbol, decimal, english, chinese, id, noSpace, price, cron };